<template>
  <section class="legal-shell" :style="{ backgroundImage: `url(${heroBg})` }">
    <div class="legal-overlay">
      <v-container class="legal-container">
        <v-card class="legal-card" elevation="10">
          <v-card-text class="legal-card-body">
            <div class="eyebrow">{{ eyebrow }}</div>
            <h1 class="legal-title">{{ title }}</h1>
            <p class="legal-subtitle">{{ subtitle }}</p>

            <div v-if="$slots.actions" class="legal-actions">
              <slot name="actions" />
            </div>

            <div class="legal-content">
              <slot />
            </div>
          </v-card-text>
        </v-card>
      </v-container>
    </div>
  </section>
</template>

<script setup>
import heroBg from '@/assets/hero-bg.jpeg';

defineProps({
  eyebrow: {
    type: String,
    default: '',
  },
  title: {
    type: String,
    required: true,
  },
  subtitle: {
    type: String,
    default: '',
  },
});
</script>

<style scoped>
.legal-shell {
  position: relative;
  width: 100%;
  height: 100vh;
  min-height: calc(100vh - 60px);
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}

.legal-overlay {
  position: absolute;
  inset: 0;
  background:
    linear-gradient(180deg, rgba(15, 23, 42, 0.58) 0%, rgba(15, 23, 42, 0.72) 100%);
  padding: 40px 16px 56px;
  overflow-y: auto;
}

.legal-container {
  max-width: 980px;
}

.legal-card {
  border-radius: 28px;
  background: rgba(255, 255, 255, 0.93);
  backdrop-filter: blur(16px);
}

.legal-card-body {
  padding: 32px;
}

.eyebrow {
  margin-bottom: 12px;
  color: #4f46e5;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.18em;
  text-transform: uppercase;
}

.legal-title {
  margin: 0;
  color: #101828;
  font-size: clamp(2rem, 4vw, 3.2rem);
  line-height: 1.05;
}

.legal-subtitle {
  max-width: 720px;
  margin: 14px 0 0;
  color: #475467;
  font-size: 1rem;
  line-height: 1.7;
}

.legal-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 24px;
}

.legal-content {
  margin-top: 28px;
}

@media (max-width: 600px) {
  .legal-overlay {
    padding: 24px 12px 40px;
  }

  .legal-card-body {
    padding: 22px 18px;
  }
}
</style>
